<template>
    <div class="d-flex flex-column align-start">
        <download-custom-document-button
            v-for="(template, index) in templates"
            :key="index"
            :order="order"
            :checkbox-services-selected="checkboxServicesSelected"
            :template="template"
            class="px-0"
        />
    </div>
</template>
<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import DownloadCustomDocumentButton from '~src/components/account/snippets/DownloadCustomDocumentButton.vue'
    import {DocumentTemplatesMixin} from '@/components/account/mixins/DocumentTemplatesMixin.vue'

    @Component({
        components: {DownloadCustomDocumentButton},
    })
    export class OrderCustomDocuments extends mixins(DocumentTemplatesMixin) {
        @Prop({required: true}) order
        @Prop() checkboxServicesSelected

        async mounted() {
            this.isLoading = true
            await this.loadDocumentTemplates()
            this.isLoading = false
        }

        get templates() {
            const templates = this.documentTemplates.filter(
                template =>
                    template.active &&
                    template.documentVisibility.includes(this.isB2C ? 'PRIVATE_CLIENT' : authStore.companyType)
            )

            if (this.$conf.public.account.licenseeForCorporateCompany) {
                return templates.filter(({documentType}) => documentType !== 'Client Invoice')
            }

            return templates
        }

        get isTO1() {
            return authStore.isTO1
        }

        get isB2C() {
            return authStore.isB2C
        }

        get companyType() {
            return authStore.companyType
        }
    }

    export default OrderCustomDocuments
</script>
